import { Injectable, TemplateRef, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { LanguageService } from '../../../../core/services/language.service';
import { UserUIModel } from '../models/UserUIModel';
import { DialogModel } from '../../../../shared/components/dialog/dialog';

@Injectable({
  providedIn: 'root',
})
export class UserDialogService {
  private readonly dialog = inject(MatDialog);
  private readonly languageService = inject(LanguageService);

  showEditUserDialog(
    templateRef: TemplateRef<Element>,
    onConfirm: () => void,
  ): DialogModel {
    const editUserDialog = new DialogModel(this.dialog);
    editUserDialog.closable = false;
    editUserDialog.headline = this.languageService.translateOnRuntime(
      'portal.users.table.editUserDialog.headline',
    );
    editUserDialog.buttonRowData = {
      confirmButtonText: this.languageService.translateOnRuntime(
        'portal.users.table.editUserDialog.confirmButtonText',
      ),
      confirmButtonAction: onConfirm,
      declineButtonText:
        this.languageService.translateOnRuntime('general.abort'),
    };
    editUserDialog.contentTemplate = templateRef;

    editUserDialog.openDialog();

    return editUserDialog;
  }

  showLicenseUnassignmentConfirmationDialog(
    user: UserUIModel,
    onConfirm: () => void,
  ): DialogModel {
    const licenseUnassignmentConfirmationDialog = new DialogModel(this.dialog);
    licenseUnassignmentConfirmationDialog.closable = true;
    licenseUnassignmentConfirmationDialog.headline =
      this.languageService.translateOnRuntime(
        'portal.users.table.unassignLicenseConfirmationDialog.headline',
      );
    licenseUnassignmentConfirmationDialog.description =
      this.languageService.translateOnRuntime(
        'portal.users.table.unassignLicenseConfirmationDialog.description',
        { name: user.username },
      );
    licenseUnassignmentConfirmationDialog.buttonRowData = {
      confirmButtonText: this.languageService.translateOnRuntime(
        'portal.users.table.unassignLicenseConfirmationDialog.confirmButtonText',
      ),
      confirmButtonAction: onConfirm,
      declineButtonText:
        this.languageService.translateOnRuntime('general.abort'),
    };

    licenseUnassignmentConfirmationDialog.openDialog();

    return licenseUnassignmentConfirmationDialog;
  }

  showDeleteConfirmationDialog(
    user: UserUIModel,
    onConfirm: () => void,
  ): DialogModel {
    const deleteConfirmationDialog = new DialogModel(this.dialog);
    deleteConfirmationDialog.closable = true;
    deleteConfirmationDialog.headline = this.languageService.translateOnRuntime(
      'portal.users.table.deleteUserConfirmationDialog.headline',
    );
    deleteConfirmationDialog.description =
      this.languageService.translateOnRuntime(
        'portal.users.table.deleteUserConfirmationDialog.description',
      );

    deleteConfirmationDialog.fourthDescription =
      this.languageService.translateOnRuntime(
        'portal.users.table.deleteUserConfirmationDialog.fourthDescription',
      );

    deleteConfirmationDialog.fifthDescription =
      this.languageService.translateOnRuntime(
        'portal.users.table.deleteUserConfirmationDialog.fifthDescription',
      );

    deleteConfirmationDialog.sixthDescription =
      this.languageService.translateOnRuntime(
        'portal.users.table.deleteUserConfirmationDialog.sixthDescription',
      );

    deleteConfirmationDialog.seventhDescription =
      this.languageService.translateOnRuntime(
        'portal.users.table.deleteUserConfirmationDialog.seventhDescription',
      );

    deleteConfirmationDialog.buttonRowData = {
      confirmButtonText: this.languageService.translateOnRuntime(
        'portal.users.table.deleteUserConfirmationDialog.confirmButtonText',
      ),
      confirmButtonAction: onConfirm,
      declineButtonText:
        this.languageService.translateOnRuntime('general.abort'),
    };

    deleteConfirmationDialog.openDialog();

    return deleteConfirmationDialog;
  }

  showPromoteToAdminConfirmationDialog(
    user: UserUIModel,
    onConfirm: () => void,
  ): DialogModel {
    const promoteToAdminConfirmationDialog = new DialogModel(this.dialog);
    promoteToAdminConfirmationDialog.closable = true;
    promoteToAdminConfirmationDialog.headline =
      this.languageService.translateOnRuntime(
        'portal.users.table.upgradeUserConfirmationDialog.headline',
      );
    promoteToAdminConfirmationDialog.fourthDescription =
      this.languageService.translateOnRuntime(
        'portal.users.table.upgradeUserConfirmationDialog.description',
        { name: user.username },
      );
    promoteToAdminConfirmationDialog.fifthDescription =
      this.languageService.translateOnRuntime(
        'portal.users.table.upgradeUserConfirmationDialog.secondDescription',
      );
    promoteToAdminConfirmationDialog.buttonRowData = {
      confirmButtonText: this.languageService.translateOnRuntime(
        'portal.users.table.upgradeUserConfirmationDialog.confirmButtonText',
      ),
      confirmButtonAction: onConfirm,
      declineButtonText:
        this.languageService.translateOnRuntime('general.abort'),
    };
    promoteToAdminConfirmationDialog.openDialog();
    return promoteToAdminConfirmationDialog;
  }
}
